
<template>
    <v-dialog v-model="showSimilarityDialog" persistent max-width="290">
        <v-card>
            <v-card-title class="headline">Similarity Checker</v-card-title>
            <v-card-text>Please type a sentence you want to compare</v-card-text>
            <v-flex><v-text-field v-model="keyword1"></v-text-field></v-flex>
            <v-flex><v-text-field v-model="keyword2"></v-text-field></v-flex>
            <v-flex v-if="theScore!==''"><span >{{ theScore }}</span></v-flex>
            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="green darken-1" text @click="closeDialog">Cancel</v-btn>
                <v-btn v-if="loading" loading disabled color="green darken-1" text @click="checkSimilarity">Check</v-btn>
                <v-btn v-else color="green darken-1" text @click="checkSimilarity">Check</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import * as use from '@tensorflow-models/universal-sentence-encoder'
export default {
  props: ['showSimilarityDialog', 'editor'],
  data () {
    return {
      keyword1: '',
      keyword2: '',
      theScore: '',
      loading: false
    }
  },
  methods: {
    closeDialog () {
      this.keyword1 = ''
      this.keyword2 = ''
      this.theScore = ''
      this.$emit('closeSimilarityDialog', false)
    },
    receiveKeywordInput (input) {
      this.keyword1 = input
    },
    checkSimilarity () {
      if (this.keyword1 === '' || this.keyword2 === '') {
        this.theScore = 'Woops! You did not type any word yet'
        return
      }
      this.loading = true
      use.load().then(model => {
        // Embed an array of sentences.
        const sentences = [
          this.keyword1,
          this.keyword2
        ]
        model.embed(sentences).then(embeddings => {
          embeddings.print(true /* verbose */)
          const sentenceX = embeddings.slice([0, 0], [1])
          const sentenceY = embeddings.slice([1, 0], [1])
          const sentenceITranspose = false
          const sentenceJTransepose = true
          const score =
            sentenceX.matMul(sentenceY, sentenceITranspose, sentenceJTransepose)
                .dataSync()
          this.theScore = parseFloat(score).toFixed(2) * 100 + '% ' + 'similar to your input'
          this.loading = false
        })
      })
    }
  },
  mounted () {
    this.editor.signals.sendKeywordInput.add(this.receiveKeywordInput)
  }
}
</script>


// WEBPACK FOOTER //
// src/components/user-class/similarityDialog.vue